import { http } from '../request'
import type { PaginationData } from '../request'
import type {
    Permission,
    PermissionListRequest,
    PermissionUpdateRequest,
    PermissionConstraintSummary
} from '../types_admin/permissions'

/**
 * 管理员权限管理 API
 * 注意：权限创建和删除被禁用，只支持查看和编辑（仅超管）
 */
export const adminPermissionsApi = {
    /**
     * 获取权限列表
     * GET /api/permissions/permissions/
     * @param params.scope - 'all' 获取所有权限，'assignable' 获取可分配权限（默认，排除超管专用）
     */
    getPermissionList(params?: PermissionListRequest): Promise<PaginationData<Permission>> {
        return http.list('/api/permissions/permissions/', params)
    },

    /**
     * 获取可用权限模块列表
     * GET /api/permissions/permissions/modules/
     */
    getPermissionModules(): Promise<string[]> {
        return http.get('/api/permissions/permissions/modules/')
    },

    /**
     * 编辑权限（仅超管）
     * PUT /api/permissions/permissions/{id}/
     */
    updatePermission(id: number, data: PermissionUpdateRequest): Promise<Permission> {
        return http.put(`/api/permissions/permissions/${id}/`, data)
    },

    /**
     * 获取权限约束摘要
     * GET /api/permissions/management/constraint-summary/
     */
    getConstraintSummary(): Promise<PermissionConstraintSummary> {
        return http.get('/api/permissions/management/constraint-summary/')
    }
}